import React from 'react';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div className="d-flex flex-column flex-root min-vh-100">
      <div className="d-flex flex-column flex-center flex-column-fluid">
        <div className="d-flex flex-column flex-center text-center p-10">
          
          <div className="card card-flush w-lg-650px py-5 border-0 shadow-sm">
            <div className="card-body py-15 py-lg-20">
              
              <h1 className="fw-bolder fs-4x text-gray-900 mb-4">404</h1>
              
              <div className="fw-semibold fs-6 text-gray-500 mb-7">
                We can't find that page.
              </div>
              
              <div className="mb-10">
                <img 
                  src="assets/404.png" 
                  className="mw-100 mh-300px theme-light-show" 
                  alt="" 
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              
              <div className="mb-0">
                <Link to="/" className="btn btn-primary">
                  Return to Dashboard
                </Link>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Error404;